<div class="request-timeline">
  <div class="step" *ngFor="let step of request?.steps;let index = index ">
    <div class="step-lines">
      <div class="dot" [attr.test-id]="'step-status' + index">
        <gp-workflow-step-status [status]="step.status"></gp-workflow-step-status>
      </div>
      <div class="line" [class.lineHidden]="step.type === 'END_STEP'"></div>
    </div>
    <div class="step-content">
      <h4>
        <ng-container *ngIf="step.type === 'START_STEP'">
          <em class="fa fa-light fa-calendar-alt"></em>
          <span
            [attr.test-id]="'start-step-create-date'">{{step.createTime | gpDate: {withHour: true}: (triggerDateChange$|async) }}</span>
        </ng-container>
        <ng-container *ngIf="step.type === 'END_STEP'">
          <em class="fa fa-light fa-calendar-alt"></em>
          <span
            [attr.test-id]="'end-step-end-date'">{{step.endTime | gpDate: {withHour: true}: (triggerDateChange$|async) }}</span>
        </ng-container>
        <ng-container *ngIf="step.type === 'TASK_STEP'">
          <em class="fa fa-light fa-calendar-alt"></em>
          <span
            [attr.test-id]="'step-' + index + '-date'">{{step.endTime ? (step.endTime | gpDate: {withHour: true}: (triggerDateChange$|async))
            : (step.createTime | gpDate: {withHour: true}: (triggerDateChange$|async))
            }}</span>
        </ng-container>
      </h4>
      <div *ngIf="step.assignee">
        <em class="fa fa-light fa-user-alt"></em>
        <strong [attr.test-id]="'step-' + index + '-assignee-full-name'"
                [tooltip]="(step.type === 'START_STEP' ?
                 'WORKFLOWS.requester' : step.type === 'END_STEP' ?
                  'WORKFLOWS.canceled_by' : 'WORKFLOWS.assignee') | translate">{{step.assignee?.fullName}}
        </strong>
      </div>
      <div *ngIf="step.comment" class="comment" [attr.test-id]="'step-' + index + '-comment'">
        <em class="fa fa-light fa-comment"></em>
        <span>{{step.comment}}</span>

      </div>
      <div *ngIf="step.candidates?.length" class="flex">
        <em class="fa fa-light fa-user-friends"></em>
        <ul
          [tooltip]="(step.assignee != null ? 'WORKFLOWS.old_candidates' : 'WORKFLOWS.candidates') | translate"
          [attr.test-id]="'step-' + index + '-candidates-list'">
          <li *ngFor="let candidate of step.candidates"
              [class.line-through]="step.assignee != null
                  && candidate.employeeNumber !== step.assignee?.employeeNumber">{{candidate?.fullName}}</li>
        </ul>
      </div>
    </div>
  </div>
</div>
